'use client'
import { disableQuery, useQuery } from '@connectrpc/connect-query'
import { getSiteRating } from '@fingertip/creator-proto/gen/fingertip/creator/rating/v1/rating-RatingService_connectquery'
import { useMemo } from 'react'

import { Spinner } from '@/components/ui/spinner'
import { useToken } from '@/lib/hooks/use-token'

import { RatingForm, Schema } from './rating-form'

type Props = {
  title?: string
  description?: string
  pageSlug: string
  siteSlug: string
  onSuccess?: () => void
}

export const RatingBlock = ({
  title = 'Leave a review',
  description = 'How would you rate this page?',
  siteSlug,
  pageSlug,
  onSuccess,
}: Props) => {
  const { session, hasFetched, callOptions } = useToken()

  const { data, error, isLoading } = useQuery(
    getSiteRating,
    !hasFetched
      ? disableQuery
      : {
          siteSlug,
        },
    {
      callOptions,
    },
  )

  const defaultValues = useMemo<Schema>(() => {
    return {
      rating: data?.rating?.rating ? String(data.rating.rating) : '',
      comment: data?.rating?.comment ?? '',
      email: session?.user?.email || '',
      name: '',
    }
  }, [data?.rating?.comment, data?.rating?.rating, session?.user?.email])

  if (error) {
    return null
  }

  return (
    <div className="ft-widget-wrapper size-full rounded-page-widget text-neutral-900">
      <div className="bg-page-widget-background shadow-page-widget border-page-widget p-block mb-fluid-1 size-full rounded-page-widget text-page-body-text backdrop-blur-page-widget">
        <h3 className="page-heading text-left text-fluid-lg">{title}</h3>

        <p className="mb-fluid-2 text-fluid-base">{description}</p>

        <RatingForm
          pageSlug={pageSlug}
          siteSlug={siteSlug}
          defaultValues={defaultValues}
          buttonVariant="blockPrimary"
          labelClassName="text-page-body-text!"
          inputClassName="bg-page-input-background text-page-input-text rounded-page-widget-block border-page-input-border shadow-page-input placeholder:text-page-input-placeholder! h-fluid-12! text-fluid-base"
          onSuccess={() => onSuccess?.()}
        />

        {isLoading && <Spinner size={24} />}
      </div>
    </div>
  )
}
